import {action, observable, runInAction} from "mobx"
import GenericFormStore from "../../../stores/FormStore";
import userStore from "../../../stores/UserStore";
import {go} from "../../../utils/navigationUtility";

class ResetPasswordStore extends GenericFormStore {
    @observable form = ResetPasswordStore.initUploadTrackForm();

    static initUploadTrackForm() {
        return {
            fields: {
                email: {
                    value: '',
                    error: '',
                    rule: 'required|email'
                },
                password: {
                    value: '',
                    error: '',
                    rule: 'required|password|confirmed',
                },
                password_confirmation: {
                    value: '',
                    error: '',
                    rule: 'required|password',
                },
                code: {
                    value: '',
                    error: '',
                    rule: 'required'
                }
            },
            meta: {
                isValid: false,
                error: null,
                code: null
            },
        };
    }

    @action handleSubmit = async () => {
        let email = this.form.fields.email.value;
        let newPassword = this.form.fields.password.value;
        let code = this.form.fields.code.value;
        try {
            await userStore.confirmNewPassword(email, code, newPassword);
            go('auth/forgot-password/success');
        } catch (err) {
            runInAction(() => {
                this.form.meta.error = err.message;
                this.form.meta.code = err.code;
                this.form.meta.isValid = false;
            })
        }
    };

    @action resendLink = async () => {
        let email = this.form.fields.email.value;
        try {
            await userStore.forgotPassword(email);
            go('auth/forgot-password/link-sent');
        } catch (err) {
            runInAction(() => {
                this.form.meta.error = err.message;
                this.form.meta.code = err.code;
                this.form.meta.isValid = false;
            })
        }

    };

    @action onClickDone = () => {
        go('/signin');
    };

}

const resetPasswordStore = new ResetPasswordStore();
export default resetPasswordStore;

